var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAmbient = function SvgAmbient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ambient_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.443 10.05a.834.834 0 0 0-.832.835v10.234c.042 1.107 1.626 1.103 1.667 0V10.885a.835.835 0 0 0-.835-.834ZM16 10.05a.835.835 0 0 0-.835.835v10.234c.042 1.105 1.629 1.105 1.67 0V10.885A.835.835 0 0 0 16 10.05ZM18.721 13.1a.834.834 0 0 0-.831.833v4.138c.042 1.106 1.625 1.102 1.667 0v-4.138a.835.835 0 0 0-.835-.833ZM24.165 14.623a.834.834 0 0 0-.832.834v1.088c.042 1.107 1.625 1.103 1.667 0v-1.088a.835.835 0 0 0-.835-.834ZM7.835 14.623a.835.835 0 0 0-.835.834v1.088c.042 1.104 1.625 1.106 1.667 0v-1.088a.834.834 0 0 0-.832-.834ZM10.557 11.574a.835.835 0 0 0-.835.834v7.186c.042 1.104 1.625 1.106 1.667 0v-7.186a.834.834 0 0 0-.832-.834ZM13.278 7.002a.835.835 0 0 0-.835.834v16.332c.042 1.104 1.626 1.106 1.667 0V7.836a.834.834 0 0 0-.832-.834Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ambient_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7 7)",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgAmbient;